<template>
    <div id="image-zoom" v-show="isZoomVisible">
        <div id="image-zoom-overlay" @click="exit"></div>
        <div id="image-zoom-loading" v-if="loading">
            <span><!--spinner--></span>
        </div>
        <div class="image-zoom-item active" v-else-if="image">
            <img :src="image.src">
            <div class="frame image-zoom-item-info text-yanone text-uppercase">
                <p class="mx-0 my-0">
                    <span v-if="image.title" class="text-bold">{{image.title}}</span>
                    <span v-if="image.description">{{image.description}}</span>
                </p>
            </div>
        </div>
        <div id="image-zoom-previous" class="cursor-pointer" v-show="hasPrevious">
            <i class="icon-cr icon-chevron-left white" @click="previous"></i>
        </div>
        <i id="image-zoom-next" class="cursor-pointer" v-show="hasNext">
            <i class="icon-cr icon-chevron-right white" @click="next"></i>
        </i>
        <div id="image-zoom-close" class="text-yanone text-uppercase cursor-pointer" @click="exit">
            Fechar
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FullScreenImage',

        props: {
            image: Object,
            current: Number,
            loading: Boolean,
            hasPrevious: Boolean,
            hasNext: Boolean
        },

        mounted() {
            window.addEventListener('keydown', this.onKeyDown.bind(this));
        },

        beforeDestroy() {
            window.removeEventListener('keydown', this.onKeyDown.bind(this));
        },

        computed: {
            isZoomVisible() {
                return this.image !== null && this.image !== undefined;
            }
        },

        methods: {
            previous() {
                if (this.loading || !this.hasPrevious) return;
                this.$emit('zoom-previous');
            },
            next() {
                if (this.loading || !this.hasNext) return;
                this.$emit('zoom-next');
            },
            exit() {
                this.$emit('zoom-exit');
            },
            onKeyDown(event) {
                if (!this.isZoomVisible) return;
                switch (event.keyCode) {
                    case 38: // up
                    case 37: // left
                        this.previous();
                        break;
                    case 32: // space
                    case 40: // down
                    case 39: // right
                        this.next();
                        break;
                }

                if ([32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) {
                    event.preventDefault(); // prevents scroll
                }
            }
        }
    }
</script>